import React from 'react';
import { useAuth } from '../context/AuthContext';
import { Card, CardContent } from '../components/ui/card';

function HealthUI() {
  const { user } = useAuth();

  return (
    <div className="min-h-screen flex items-center justify-center p-4 bg-background">
      <Card className="max-w-md w-full bg-white/5 backdrop-blur-md border border-green-500/20">
        <CardContent className="p-8 text-center">
          <div className="mb-6">
            <div className="w-16 h-16 bg-green-500/20 rounded-full flex items-center justify-center mx-auto mb-4">
              <span className="text-3xl">✅</span>
            </div>
            <h1 className="text-3xl font-bold text-green-400 mb-2">
              OK
            </h1>
            <p className="text-muted-foreground">
              BarsConnect Frontend is running
            </p>
          </div>

          <div className="bg-white/5 border border-white/10 rounded-lg p-4 text-left">
            <h2 className="text-sm font-semibold text-white mb-2">Status:</h2>
            <ul className="space-y-2 text-sm">
              <li className="flex items-center gap-2">
                <span className="text-green-400">●</span>
                <span className="text-muted-foreground">React App Running</span>
              </li>
              <li className="flex items-center gap-2">
                <span className="text-green-400">●</span>
                <span className="text-muted-foreground">
                  Auth Context: {user ? 'Logged In' : 'Logged Out'}
                </span>
              </li>
              {user && (
                <>
                  <li className="flex items-center gap-2">
                    <span className="text-green-400">●</span>
                    <span className="text-muted-foreground">
                      Email: {user.email}
                    </span>
                  </li>
                  <li className="flex items-center gap-2">
                    <span className="text-green-400">●</span>
                    <span className="text-muted-foreground">
                      Role: {user.user_type}
                    </span>
                  </li>
                  <li className="flex items-center gap-2">
                    <span className="text-green-400">●</span>
                    <span className="text-muted-foreground">
                      Admin: {user.is_admin ? 'Yes' : 'No'}
                    </span>
                  </li>
                </>
              )}
            </ul>
          </div>

          <div className="mt-6 space-y-2">
            <button
              onClick={() => window.location.href = '/'}
              className="w-full bg-primary text-white px-4 py-2 rounded-md hover:bg-[hsl(var(--primary-light))]"
            >
              Go to Homepage
            </button>
            {user ? (
              <button
                onClick={() => window.location.href = '/dashboard'}
                className="w-full bg-white/10 text-white px-4 py-2 rounded-md hover:bg-white/20"
              >
                Go to Dashboard
              </button>
            ) : (
              <button
                onClick={() => window.location.href = '/login'}
                className="w-full bg-white/10 text-white px-4 py-2 rounded-md hover:bg-white/20"
              >
                Login
              </button>
            )}
          </div>
        </CardContent>
      </Card>
    </div>
  );
}

export default HealthUI;
